<app-exam-header [pageTitle]="event.name"></app-exam-header>
<div class="page-content"> 

    <!-- Blog Details -->
    <section>
        <div class="container">
            <div class="row">
                <div class="col-lg-9 blog-right-col">
                    <div class="row">
                        <div class="col-md-12">
                            <article class="post blog-details"> 
                                <div class="blog-classic">  
                                    <div class="pbmit-featured-img-wrapper">
                                        <!-- New Date Badge -->
                                        <div class="date-badge">
                                            <span class="date-day">{{event.event_date|date:'dd'}}</span>
                                            <div class="date-divider"></div>
                                            <div class="date-month-year">
                                                <span class="date-month">{{event.event_date|date:'MMM'}}</span>
                                                <span class="date-year">{{event.event_date|date:'yyyy'}}</span>
                                            </div>
                                        </div>
                                        <!-- Old Date Badge (hidden with CSS) -->
                                        <div class="pbmit-meta-date-wrapper">					
                                            <span class="pbmit-day">{{event.event_date|date:'dd'}}</span>
                                            <span>{{event.event_date|date:'MMM'}}</span>
                                        </div>
                                        <div class="pbmit-featured-wrapper">
                                            <img [src]="siteUrl+'api/static'+event.image" class="img-fluid w-100" alt="">
                                        </div>
                                    </div>  
                                    <div class="pbmit-blog-classic-inner" [innerHTML]="event.description">
                                       
                                    </div>
                                </div>
                            </article> 
                        </div> 
                    </div>
                </div>
                <div class="col-lg-3 blog-left-col">
                    <aside class="sidebar">
                        <aside class="widget widget-recent-post">
                            <h2 class="widget-title">Recent Events</h2>
                            <ul class="recent-post-list">
                                <li class="recent-post-list-li" *ngFor="let event of recentEvents"> 
                                    <a class="recent-post-thum" [routerLink]="['/event', event.id]">
                                        <img [src]="siteUrl+'api/static'+event.image" class="img-fluid w-100" alt="">
                                    </a>
                                    <div class="media-body">
                                        <span class="post-title">
                                            <a href="event/{{event.id}}">{{event.name}}</a>
                                        </span>
                                        <span class="post-date">
                                            <a >{{event.event_date | date:'MMM d, yyyy'}}</a>
                                        </span>
                                    </div> 
                                </li>
                            </ul>
                        </aside>
                        <aside class="widget widget-categories">
                            <h2 class="widget-title">Categories</h2>
                            <ul>
                                <li *ngFor="let category of categoryList"><a href="/events" class="categeory-box"><div style="color: rgb(255, 255, 255);">{{category}}</div></a><span>{{categories[category]}}</span></li>
                            </ul>
                        </aside>
                    </aside>
                </div>
            </div>
        </div>
    </section>
    <!-- Blog Details End -->
    
</div><app-exam-footer></app-exam-footer>